import { Skeleton } from "@mui/material";
import SortedItemsList, {
  ItemListElement,
} from "../../../../components/SortedItemsList/SortedItemsList";
import { TeamWithCount } from "../../../../services/shirts/types";
import defaultAvatar from "../../../../img/defaultProfile.jpg";
import { useEffect, useState } from "react";

interface TopTeamsProps {
  teams: Array<TeamWithCount>;
  pathAll: string;
  onClick: Function;
}

const TopTeams = ({ teams, pathAll, onClick }: TopTeamsProps) => {
  const title = "Most popular teams";

  const [list, setList] = useState<Array<ItemListElement> | undefined>(
    undefined,
  );
  const [teamId, setTeamId] = useState<number | undefined>(undefined);

  useEffect(() => {
    setList(
      teams
        .map((team) => {
          return {
            id: team.id,
            name: team.name,
            value: team.appearances,
            logo: team.logo,
          };
        })
        .sort((a, b) => b.value - a.value),
    );
  }, [teams]);

  useEffect(() => {
    if (teamId !== undefined) {
      onClick(teamId);
    }
  }, [teamId]);

  const renderValue = (value: number) => {
    return String(value) + " shirts";
  };

  return list ? (
    <SortedItemsList
      list={list}
      title={title}
      renderValue={renderValue}
      defaultAvatarImg={defaultAvatar}
      fullListUrl={pathAll}
      onClick={setTeamId}
      maxItems={5}
    />
  ) : (
    <Skeleton variant="rectangular" width={210} height={30} />
  );
};

export default TopTeams;
